import axiosHook from './axios';
import axios from 'axios';

const axiosAll = async urls => {
  return await axios.all(urls.map(url => axiosHook('get', url)));
};

export default axiosAll;
